import { render, staticRenderFns } from "./_left-app.vue?vue&type=template&id=6cd201ec&scoped=true"
import script from "./_left-app.vue?vue&type=script&lang=js"
export * from "./_left-app.vue?vue&type=script&lang=js"
import style0 from "./_left-app.vue?vue&type=style&index=0&id=6cd201ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd201ec",
  null
  
)

export default component.exports